export const NAVIGATION_SECTIONS = {
  WORK: 'work',
  PATIENTS: 'patients',
  GROWTH_INTELLIGENCE: 'growth_intelligence',
  LUCI_AGENT: 'luci_agent',
  ADMINISTRATION: 'administration',
};

const SECTION_DEFINITIONS = [
  {
    name: NAVIGATION_SECTIONS.WORK,
    itemNames: ['Inbox', 'Conversation'],
  },
  {
    name: NAVIGATION_SECTIONS.PATIENTS,
    itemNames: ['Contacts', 'Sales Funnel', 'Basic Results'],
  },
  {
    name: NAVIGATION_SECTIONS.GROWTH_INTELLIGENCE,
    itemNames: ['Growth Analytics', 'Growth Exports'],
  },
  {
    name: NAVIGATION_SECTIONS.LUCI_AGENT,
    itemNames: ['Luci Status', 'Luci Configuration'],
  },
  {
    name: NAVIGATION_SECTIONS.ADMINISTRATION,
    itemNames: [
      'Channels and Integrations',
      'Commercial Content',
      'Clinic Settings',
      'Help Resources',
    ],
  },
];

export const buildNavigationSections = ({ items, labels }) => {
  const itemsByName = new Map(items.map(item => [item.name, item]));

  return SECTION_DEFINITIONS.map(section => ({
    name: section.name,
    label: labels[section.name],
    items: section.itemNames.map(name => itemsByName.get(name)).filter(Boolean),
  })).filter(section => section.items.length > 0);
};

export const queryMatchesDestination = ({ route, destination }) => {
  return Object.entries(destination.query || {}).every(([key, value]) => {
    return String(route.query[key] ?? '') === String(value ?? '');
  });
};

export const routeMatchesDestination = ({ route, destination, resolvePath }) =>
  Boolean(
    destination &&
      route.path === resolvePath(destination) &&
      queryMatchesDestination({ route, destination })
  );
